var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightquote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 14.64C22.7467 14.0533 21.7067 13.1733 20.96 12C20.2133 10.8267 19.84 9.44 19.84 7.84C19.84 5.54667 20.56 3.68 22 2.24C23.44 0.853335 25.28 0.160001 27.52 0.160001C29.76 0.160001 31.6267 0.880001 33.12 2.32C34.56 3.76 35.28 5.6 35.28 7.84C35.28 8.90667 35.1467 9.97333 34.88 11.04C34.6133 12.1067 34.0267 13.7067 33.12 15.84L28.48 27.36L20.56 27.36L24.08 14.64ZM5.2 14.64C3.86666 14.0533 2.82666 13.1733 2.08 12C1.33333 10.8267 0.959998 9.44 0.959998 7.84C0.959998 5.54667 1.68 3.68 3.12 2.24C4.56 0.853335 6.4 0.160001 8.64 0.160001C10.88 0.160001 12.7467 0.880001 14.24 2.32C15.68 3.76 16.4 5.6 16.4 7.84C16.4 8.90667 16.2667 9.97333 16 11.04C15.7333 12.1067 15.1467 13.7067 14.24 15.84L9.6 27.36H1.68L5.2 14.64Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightquote);
export default __webpack_public_path__ + "static/media/right quote.180db55e.svg";
export { ForwardRef as ReactComponent };